import { apiRequest } from "./client";

export interface TraineeProgress {
  user_id: number;
  full_name: string;
  login: string;
  course_id: number | null;
  course_title: string | null;
  lessons_total: number;
  lessons_completed: number;
  percent: number;
  last_activity_at: string | null;
}

export interface CuratorDashboard {
  total_trainees: number;
  avg_percent: number;
  at_risk_count: number;
  completed_30d: number;
  progress_buckets: Record<string, number>;
  at_risk: TraineeProgress[];
  ready_for_exam: TraineeProgress[];
}

export interface CourseStats {
  course_id: number;
  course_title: string;
  status: string;
  assigned_count: number;
  completed_count: number;
  avg_percent: number;
}

export interface LessonStuck {
  lesson_id: number;
  title: string;
  started_count: number;
  completed_count: number;
  drop_off_percent: number;
}

export interface ContentDashboard {
  courses: CourseStats[];
  stuck_lessons: LessonStuck[];
}

export function curatorDashboard(): Promise<CuratorDashboard> {
  return apiRequest<CuratorDashboard>("/analytics/curator");
}

export function contentDashboard(): Promise<ContentDashboard> {
  return apiRequest<ContentDashboard>("/analytics/content");
}

// Admit flow

export interface AdmitChecklist {
  user_id: number;
  course_id: number;
  course_title: string;
  lessons_total: number;
  lessons_completed: number;
  final_quiz_required: boolean;
  final_quiz_passed: boolean | null;
  requires_curator_exam: boolean;
  can_admit: boolean;
}

export function admitChecklist(
  userId: number,
  courseId: number,
): Promise<AdmitChecklist> {
  return apiRequest<AdmitChecklist>(
    `/users/${userId}/courses/${courseId}/admit-checklist`,
  );
}

export function recordExamResult(
  userId: number,
  payload: { course_id: number; passed: boolean; score?: number; notes?: string },
): Promise<void> {
  return apiRequest<void>(`/users/${userId}/exam-result`, {
    method: "POST",
    body: payload,
  });
}

export interface PromoteResult {
  user_id: number;
  course_id: number;
  new_role: string;
  completion_id: number;
}

export function promote(
  userId: number,
  payload: { course_id: number; exam_score?: number },
): Promise<PromoteResult> {
  return apiRequest<PromoteResult>(`/users/${userId}/promote`, {
    method: "POST",
    body: payload,
  });
}
